// Multi-step selection flows for Finestre, Portafinestre, Scorrevoli, Porte
// Flow: Step 1 (Tipo) → Step 2 (Sopraluce/Sottoluce) → Step 3 (Tipo di Apertura) → [Porte: Step 4 Pannello]
import { doorPanels } from './productConfig';

// ====== 1 ANTA OPENING TYPES ======
const aperture1Anta = [
  { id: 'fisso', name: 'Fisso', icon: 'open_1_fisso' },
  { id: 'battente_sx', name: 'Battente SX', icon: 'open_1_battente_sx' },
  { id: 'battente_dx', name: 'Battente DX', icon: 'open_1_battente_dx' },
  { id: 'anta_ribalta_sx', name: 'Anta-Ribalta SX', icon: 'open_1_antaribalta_sx' },
  { id: 'anta_ribalta_dx', name: 'Anta-Ribalta DX', icon: 'open_1_antaribalta_dx' },
  { id: 'vasistas', name: 'Vasistas', icon: 'open_1_vasistas' },
  { id: 'bilico_orizzontale', name: 'Bilico Orizzontale', icon: 'open_1_bilico_h' },
  { id: 'bilico_verticale', name: 'Bilico Verticale', icon: 'open_1_bilico_v' },
];

// ====== 2 ANTE OPENING TYPES ======
const aperture2Ante = [
  { id: '2_fisso_fisso', name: 'Fisso + Fisso', icon: 'open_2_fisso_fisso' },
  { id: '2_battente_sx_battente_dx', name: 'Battente SX + Battente DX', icon: 'open_2_batt_sx_batt_dx' },
  { id: '2_ar_sx_ar_dx', name: 'Anta-Ribalta SX + Anta-Ribalta DX', icon: 'open_2_ar_sx_ar_dx' },
  { id: '2_fisso_battente_dx', name: 'Fisso + Battente DX', icon: 'open_2_fisso_batt_dx' },
  { id: '2_battente_sx_fisso', name: 'Battente SX + Fisso', icon: 'open_2_batt_sx_fisso' },
  { id: '2_fisso_ar_dx', name: 'Fisso + Anta-Ribalta DX', icon: 'open_2_fisso_ar_dx' },
  { id: '2_ar_sx_fisso', name: 'Anta-Ribalta SX + Fisso', icon: 'open_2_ar_sx_fisso' },
  { id: '2_battente_sx_ar_dx', name: 'Battente SX + Anta-Ribalta DX', icon: 'open_2_batt_sx_ar_dx' },
  { id: '2_ar_sx_battente_dx', name: 'Anta-Ribalta SX + Battente DX', icon: 'open_2_ar_sx_batt_dx' },
  { id: '2_fisso_vasistas', name: 'Fisso + Vasistas', icon: 'open_2_fisso_vas' },
  { id: '2_vasistas_fisso', name: 'Vasistas + Fisso', icon: 'open_2_vas_fisso' },
  { id: '2_vasistas_vasistas', name: 'Vasistas + Vasistas', icon: 'open_2_vas_vas' },
];

// ====== 3 ANTE OPENING TYPES ======
const aperture3Ante = [
  { id: '3_fisso_fisso_fisso', name: 'Fisso + Fisso + Fisso', icon: 'open_3_fff' },
  { id: '3_batt_sx_fisso_batt_dx', name: 'Batt. SX + Fisso + Batt. DX', icon: 'open_3_bsf_bd' },
  { id: '3_ar_sx_fisso_ar_dx', name: 'AR SX + Fisso + AR DX', icon: 'open_3_ar_f_ar' },
  { id: '3_fisso_batt_sx_batt_dx', name: 'Fisso + Batt. SX + Batt. DX', icon: 'open_3_f_bs_bd' },
  { id: '3_batt_sx_batt_dx_fisso', name: 'Batt. SX + Batt. DX + Fisso', icon: 'open_3_bs_bd_f' },
  { id: '3_ar_sx_ar_dx_fisso', name: 'AR SX + AR DX + Fisso', icon: 'open_3_ar_ar_f' },
  { id: '3_fisso_ar_sx_ar_dx', name: 'Fisso + AR SX + AR DX', icon: 'open_3_f_ar_ar' },
  { id: '3_batt_sx_batt_dx_batt_dx', name: 'Batt. SX + Batt. DX + Batt. DX', icon: 'open_3_bs_bd_bd' },
];

// ====== FORME ATIPICHE ======
const formeAtipiche = [
  { id: 'oblo', name: 'Oblò / Rotondo', icon: 'circleWindow', subcategoryId: 'finestra_oblo' },
  { id: 'centinata_1', name: 'Centinata 1 Anta', icon: 'quadrantWindow', subcategoryId: 'finestra_quadrante' },
  { id: 'centinata_2', name: 'Centinata 2 Ante', icon: 'arch2Window', subcategoryId: 'finestra_centinata_2_ante' },
  { id: 'triangolare', name: 'Triangolare', icon: 'triangleWindow', subcategoryId: 'finestra_triangolo' },
  { id: 'trapezoidale', name: 'Trapezoidale', icon: 'trapezoidWindow', subcategoryId: 'finestra_trapezoidale' },
];

// ====== PORTAFINESTRA 1 ANTA OPENINGS ======
const aperturePorta1Anta = [
  { id: 'pf_battente_sx', name: 'Battente SX', icon: 'open_pf1_battente_sx' },
  { id: 'pf_battente_dx', name: 'Battente DX', icon: 'open_pf1_battente_dx' },
  { id: 'pf_ar_sx', name: 'Anta-Ribalta SX', icon: 'open_pf1_ar_sx' },
  { id: 'pf_ar_dx', name: 'Anta-Ribalta DX', icon: 'open_pf1_ar_dx' },
];

// ====== PORTAFINESTRA 2 ANTE OPENINGS ======
const aperturePorta2Ante = [
  { id: 'pf_2_batt_sx_batt_dx', name: 'Battente SX + Battente DX', icon: 'open_pf2_batt_batt' },
  { id: 'pf_2_ar_sx_ar_dx', name: 'AR SX + AR DX', icon: 'open_pf2_ar_ar' },
  { id: 'pf_2_fisso_batt_dx', name: 'Fisso + Battente DX', icon: 'open_pf2_fisso_batt' },
  { id: 'pf_2_batt_sx_fisso', name: 'Battente SX + Fisso', icon: 'open_pf2_batt_fisso' },
  { id: 'pf_2_fisso_ar_dx', name: 'Fisso + AR DX', icon: 'open_pf2_fisso_ar' },
  { id: 'pf_2_ar_sx_fisso', name: 'AR SX + Fisso', icon: 'open_pf2_ar_fisso' },
  { id: 'pf_2_batt_sx_ar_dx', name: 'Battente SX + AR DX', icon: 'open_pf2_batt_ar' },
  { id: 'pf_2_ar_sx_batt_dx', name: 'AR SX + Battente DX', icon: 'open_pf2_ar_batt' },
];

// ====== PORTAFINESTRA 3 ANTE OPENINGS ======
const aperturePorta3Ante = [
  { id: 'pf_3_batt_sx_fisso_batt_dx', name: 'Batt. SX + Fisso + Batt. DX', icon: 'open_pf3_bsf_bd' },
  { id: 'pf_3_ar_sx_fisso_ar_dx', name: 'AR SX + Fisso + AR DX', icon: 'open_pf3_ar_f_ar' },
  { id: 'pf_3_fisso_batt_sx_batt_dx', name: 'Fisso + Batt. SX + Batt. DX', icon: 'open_pf3_f_bs_bd' },
  { id: 'pf_3_batt_sx_batt_dx_fisso', name: 'Batt. SX + Batt. DX + Fisso', icon: 'open_pf3_bs_bd_f' },
  { id: 'pf_3_fisso_fisso_fisso', name: 'Fisso + Fisso + Fisso', icon: 'open_pf3_fff' },
];

// ====== PORTAFINESTRA 4 ANTE OPENINGS ======
const aperturePorta4Ante = [
  { id: 'pf_4_batt_batt_batt_batt', name: 'Batt. SX + Batt. DX + Batt. SX + Batt. DX', icon: 'open_pf4_batt_batt_batt_batt' },
  { id: 'pf_4_ar_ar_ar_ar', name: 'AR + AR + AR + AR', icon: 'open_pf4_ar_ar_ar_ar' },
  { id: 'pf_4_fisso_batt_batt_fisso', name: 'Fisso + Batt. + Batt. + Fisso', icon: 'open_pf4_fisso_batt_batt_fisso' },
  { id: 'pf_4_batt_fisso_fisso_batt', name: 'Batt. + Fisso + Fisso + Batt.', icon: 'open_pf4_batt_fisso_fisso_batt' },
];

// ====== SCORREVOLI OPENINGS ======
const apertureScorrevoli2 = [
  { id: 'scor_2_sx', name: 'Scorrevole SX', icon: 'open_scor2_sx' },
  { id: 'scor_2_dx', name: 'Scorrevole DX', icon: 'open_scor2_dx' },
];

const apertureScorrevoli3 = [
  { id: 'scor_3_sx', name: 'Scorrevole SX + Fisso + Fisso', icon: 'open_scor3_sx' },
  { id: 'scor_3_dx', name: 'Fisso + Fisso + Scorrevole DX', icon: 'open_scor3_dx' },
];

const apertureScorrevoli4 = [
  { id: 'scor_4_centrale', name: 'Fisso + Scor. DX + Scor. SX + Fisso', icon: 'open_scor4_centrale' },
];

// ====== PATIO SCORRI-RIBALTA OPENINGS ======
const aperturePatio2 = [
  { id: 'patio_2_sr_dx', name: 'Scorri-Ribalta DX', icon: 'open_patio2_sr_dx' },
  { id: 'patio_2_sr_sx', name: 'Scorri-Ribalta SX', icon: 'open_patio2_sr_sx' },
];

const aperturePatio3 = [
  { id: 'patio_3_f_sr_sx_f', name: 'Fisso + SR (apre SX) + Fisso', icon: 'open_patio3_f_sr_sx_f' },
  { id: 'patio_3_f_sr_dx_f', name: 'Fisso + SR (apre DX) + Fisso', icon: 'open_patio3_f_sr_dx_f' },
];

const aperturePatio4 = [
  { id: 'patio_4_f_sr_sr_f', name: 'Fisso + SR SX + SR DX + Fisso', icon: 'open_patio4_f_sr_sr_f' },
  { id: 'patio_4_sr_sr_f_f', name: 'SR SX + SR SX + Fisso + Fisso', icon: 'open_patio4_sr_sr_f_f' },
  { id: 'patio_4_f_f_sr_sr', name: 'Fisso + Fisso + SR DX + SR DX', icon: 'open_patio4_f_f_sr_sr' },
];

// ====== TRANSOM OPTIONS PER CONFIGURATION ======

// Finestre
const transomOptions1Anta = [
  { id: 'senza', name: 'Senza sopraluce/sottoluce', icon: 'singleSash', subcategoryId: 'finestra_1_anta' },
  { id: 'con_sopraluce', name: 'Con sopraluce', icon: 'singleWithTopLight', subcategoryId: 'finestra_1_anta_sopraluce' },
  { id: 'con_sottoluce', name: 'Con sottoluce', icon: 'singleWithBottomLight', subcategoryId: 'finestra_1_anta_sottoluce' },
];

const transomOptions2Ante = [
  { id: 'senza', name: 'Senza sopraluce/sottoluce', icon: 'doubleSash', subcategoryId: 'finestra_2_ante' },
  { id: 'con_sopraluce', name: 'Con sopraluce', icon: 'doubleWithTopLight', subcategoryId: 'finestra_2_ante_sopraluce' },
];

const transomOptions3Ante = [
  { id: 'senza', name: 'Senza sopraluce/sottoluce', icon: 'tripleSash', subcategoryId: 'finestra_3_ante' },
];

// Portafinestre — solo sopraluce (come da video)
const transomOptionsPF1 = [
  { id: 'senza', name: 'Senza sopraluce', icon: 'frenchDoor', subcategoryId: 'portafinestra_1_anta' },
  { id: 'con_sopraluce', name: 'Con sopraluce', icon: 'singleWithTopLight', subcategoryId: 'portafinestra_1_anta_sopraluce' },
];

const transomOptionsPF2 = [
  { id: 'senza', name: 'Senza sopraluce', icon: 'doubleFrenchDoor', subcategoryId: 'portafinestra_2_ante' },
  { id: 'con_sopraluce', name: 'Con sopraluce', icon: 'doubleWithTopLight', subcategoryId: 'portafinestra_2_ante_sopraluce' },
];

const transomOptionsPF3 = [
  { id: 'senza', name: 'Senza sopraluce', icon: 'tripleFrenchDoor', subcategoryId: 'portafinestra_3_ante' },
  { id: 'con_sopraluce', name: 'Con sopraluce', icon: 'tripleWithTopLight', subcategoryId: 'portafinestra_3_ante_sopraluce' },
];

const transomOptionsPF4 = [
  { id: 'senza', name: 'Senza sopraluce', icon: 'quadFrenchDoor', subcategoryId: 'portafinestra_4_ante' },
  { id: 'con_sopraluce', name: 'Con sopraluce', icon: 'quadWithTopLight', subcategoryId: 'portafinestra_4_ante_sopraluce' },
];

// ====== MAIN SELECTION FLOWS ======

// ====== PORTE D'INGRESSO OPENINGS ======
// Solo Porta
const aperturePortaSola = [
  { id: 'porta_batt_dx_est', name: 'Battente DX verso Esterno', icon: 'open_porta_batt_dx_est' },
  { id: 'porta_batt_sx_est', name: 'Battente SX verso Esterno', icon: 'open_porta_batt_sx_est' },
  { id: 'porta_batt_dx_int', name: 'Battente DX verso Interno', icon: 'open_porta_batt_dx_int' },
  { id: 'porta_batt_sx_int', name: 'Battente SX verso Interno', icon: 'open_porta_batt_sx_int' },
];
// Solo Porta + Sopraluce
const aperturePortaSolaS = [
  { id: 'porta_s_batt_dx_est', name: 'Battente DX verso Esterno', icon: 'open_porta_s_batt_dx_est' },
  { id: 'porta_s_batt_sx_est', name: 'Battente SX verso Esterno', icon: 'open_porta_s_batt_sx_est' },
  { id: 'porta_s_batt_dx_int', name: 'Battente DX verso Interno', icon: 'open_porta_s_batt_dx_int' },
  { id: 'porta_s_batt_sx_int', name: 'Battente SX verso Interno', icon: 'open_porta_s_batt_sx_int' },
];
// Porta + Fisso SX
const aperturePortaFissoSx = [
  { id: 'porta_fsx_batt_dx_est', name: 'Battente DX verso Esterno', icon: 'open_porta_fsx_batt_dx_est' },
  { id: 'porta_fsx_batt_sx_est', name: 'Battente SX verso Esterno', icon: 'open_porta_fsx_batt_sx_est' },
  { id: 'porta_fsx_batt_dx_int', name: 'Battente DX verso Interno', icon: 'open_porta_fsx_batt_dx_int' },
  { id: 'porta_fsx_batt_sx_int', name: 'Battente SX verso Interno', icon: 'open_porta_fsx_batt_sx_int' },
];
// Porta + Fisso SX + Sopraluce
const aperturePortaFissoSxS = [
  { id: 'porta_fsx_s_batt_dx_est', name: 'Battente DX verso Esterno', icon: 'open_porta_fsx_s_batt_dx_est' },
  { id: 'porta_fsx_s_batt_sx_est', name: 'Battente SX verso Esterno', icon: 'open_porta_fsx_s_batt_sx_est' },
  { id: 'porta_fsx_s_batt_dx_int', name: 'Battente DX verso Interno', icon: 'open_porta_fsx_s_batt_dx_int' },
  { id: 'porta_fsx_s_batt_sx_int', name: 'Battente SX verso Interno', icon: 'open_porta_fsx_s_batt_sx_int' },
];
// Porta + Fisso DX
const aperturePortaFissoDx = [
  { id: 'porta_fdx_batt_dx_est', name: 'Battente DX verso Esterno', icon: 'open_porta_fdx_batt_dx_est' },
  { id: 'porta_fdx_batt_sx_est', name: 'Battente SX verso Esterno', icon: 'open_porta_fdx_batt_sx_est' },
  { id: 'porta_fdx_batt_dx_int', name: 'Battente DX verso Interno', icon: 'open_porta_fdx_batt_dx_int' },
  { id: 'porta_fdx_batt_sx_int', name: 'Battente SX verso Interno', icon: 'open_porta_fdx_batt_sx_int' },
];
// Porta + Fisso DX + Sopraluce
const aperturePortaFissoDxS = [
  { id: 'porta_fdx_s_batt_dx_est', name: 'Battente DX verso Esterno', icon: 'open_porta_fdx_s_batt_dx_est' },
  { id: 'porta_fdx_s_batt_sx_est', name: 'Battente SX verso Esterno', icon: 'open_porta_fdx_s_batt_sx_est' },
  { id: 'porta_fdx_s_batt_dx_int', name: 'Battente DX verso Interno', icon: 'open_porta_fdx_s_batt_dx_int' },
  { id: 'porta_fdx_s_batt_sx_int', name: 'Battente SX verso Interno', icon: 'open_porta_fdx_s_batt_sx_int' },
];

// Transom options for porte ingresso
const transomPortaSola = [
  { id: 'porta_no_sopra', name: 'Senza Sopraluce', icon: 'entryDoorNoSopra', openingTypes: aperturePortaSola },
  { id: 'porta_con_sopra', name: 'Con Sopraluce', icon: 'entryDoorConSopra', openingTypes: aperturePortaSolaS },
];

const transomPortaFissoSx = [
  { id: 'porta_fsx_no_sopra', name: 'Senza Sopraluce', icon: 'entryDoorFissoSxNoSopra', openingTypes: aperturePortaFissoSx },
  { id: 'porta_fsx_con_sopra', name: 'Con Sopraluce', icon: 'entryDoorFissoSxConSopra', openingTypes: aperturePortaFissoSxS },
];

const transomPortaFissoDx = [
  { id: 'porta_fdx_no_sopra', name: 'Senza Sopraluce', icon: 'entryDoorFissoDxNoSopra', openingTypes: aperturePortaFissoDx },
  { id: 'porta_fdx_con_sopra', name: 'Con Sopraluce', icon: 'entryDoorFissoDxConSopra', openingTypes: aperturePortaFissoDxS },
];

// Porta + Semifisso SX
const aperturePortaSemifissoSx = [
  { id: 'porta_sfsx_batt_dx_est', name: 'Battente DX verso Esterno', icon: 'open_porta_sfsx_batt_dx_est' },
  { id: 'porta_sfsx_batt_sx_est', name: 'Battente SX verso Esterno', icon: 'open_porta_sfsx_batt_sx_est' },
  { id: 'porta_sfsx_batt_dx_int', name: 'Battente DX verso Interno', icon: 'open_porta_sfsx_batt_dx_int' },
  { id: 'porta_sfsx_batt_sx_int', name: 'Battente SX verso Interno', icon: 'open_porta_sfsx_batt_sx_int' },
];
// Porta + Semifisso SX + Sopraluce
const aperturePortaSemifissoSxS = [
  { id: 'porta_sfsx_s_batt_dx_est', name: 'Battente DX verso Esterno', icon: 'open_porta_sfsx_s_batt_dx_est' },
  { id: 'porta_sfsx_s_batt_sx_est', name: 'Battente SX verso Esterno', icon: 'open_porta_sfsx_s_batt_sx_est' },
  { id: 'porta_sfsx_s_batt_dx_int', name: 'Battente DX verso Interno', icon: 'open_porta_sfsx_s_batt_dx_int' },
  { id: 'porta_sfsx_s_batt_sx_int', name: 'Battente SX verso Interno', icon: 'open_porta_sfsx_s_batt_sx_int' },
];
// Porta + Semifisso DX
const aperturePortaSemifissoDx = [
  { id: 'porta_sfdx_batt_dx_est', name: 'Battente DX verso Esterno', icon: 'open_porta_sfdx_batt_dx_est' },
  { id: 'porta_sfdx_batt_sx_est', name: 'Battente SX verso Esterno', icon: 'open_porta_sfdx_batt_sx_est' },
  { id: 'porta_sfdx_batt_dx_int', name: 'Battente DX verso Interno', icon: 'open_porta_sfdx_batt_dx_int' },
  { id: 'porta_sfdx_batt_sx_int', name: 'Battente SX verso Interno', icon: 'open_porta_sfdx_batt_sx_int' },
];
// Porta + Semifisso DX + Sopraluce
const aperturePortaSemifissoDxS = [
  { id: 'porta_sfdx_s_batt_dx_est', name: 'Battente DX verso Esterno', icon: 'open_porta_sfdx_s_batt_dx_est' },
  { id: 'porta_sfdx_s_batt_sx_est', name: 'Battente SX verso Esterno', icon: 'open_porta_sfdx_s_batt_sx_est' },
  { id: 'porta_sfdx_s_batt_dx_int', name: 'Battente DX verso Interno', icon: 'open_porta_sfdx_s_batt_dx_int' },
  { id: 'porta_sfdx_s_batt_sx_int', name: 'Battente SX verso Interno', icon: 'open_porta_sfdx_s_batt_sx_int' },
];

// Transom options
const transomPortaSemifissoSx = [
  { id: 'porta_sfsx_no_sopra', name: 'Senza Sopraluce', icon: 'entryDoorSemifissoSxNoSopra', openingTypes: aperturePortaSemifissoSx },
  { id: 'porta_sfsx_con_sopra', name: 'Con Sopraluce', icon: 'entryDoorSemifissoSxConSopra', openingTypes: aperturePortaSemifissoSxS },
];
const transomPortaSemifissoDx = [
  { id: 'porta_sfdx_no_sopra', name: 'Senza Sopraluce', icon: 'entryDoorSemifissoDxNoSopra', openingTypes: aperturePortaSemifissoDx },
  { id: 'porta_sfdx_con_sopra', name: 'Con Sopraluce', icon: 'entryDoorSemifissoDxConSopra', openingTypes: aperturePortaSemifissoDxS },
];

export const selectionFlows = {
  finestre: {
    label: 'Finestre',
    steps: [
      {
        id: 'tipo',
        title: 'TIPO DI FINESTRA',
        subtitle: 'Seleziona il numero di ante',
        options: [
          {
            id: '1_anta',
            name: 'A 1 Anta',
            icon: 'singleSash',
            transomOptions: transomOptions1Anta,
            openingTypes: aperture1Anta,
          },
          {
            id: '2_ante',
            name: 'A 2 Ante',
            icon: 'doubleSash',
            transomOptions: transomOptions2Ante,
            openingTypes: aperture2Ante,
          },
          {
            id: '3_ante',
            name: 'A 3 Ante',
            icon: 'tripleSash',
            transomOptions: transomOptions3Ante,
            openingTypes: aperture3Ante,
          },
          {
            id: 'forme_atipiche',
            name: 'Forme Atipiche',
            icon: 'atypicalShape',
            isAtypical: true,
            atypicalOptions: formeAtipiche,
          },
        ],
      },
    ],
  },

  portafinestre: {
    label: 'Portafinestre',
    steps: [
      {
        id: 'tipo',
        title: 'TIPO DI PORTAFINESTRA',
        subtitle: 'Seleziona il numero di ante',
        options: [
          {
            id: 'pf_1_anta',
            name: '1 Anta',
            icon: 'frenchDoor',
            transomOptions: transomOptionsPF1,
            openingTypes: aperturePorta1Anta,
          },
          {
            id: 'pf_2_ante',
            name: 'A 2 Ante',
            icon: 'doubleFrenchDoor',
            transomOptions: transomOptionsPF2,
            openingTypes: aperturePorta2Ante,
          },
          {
            id: 'pf_3_ante',
            name: 'A 3 Ante',
            icon: 'tripleFrenchDoor',
            transomOptions: transomOptionsPF3,
            openingTypes: aperturePorta3Ante,
          },
          {
            id: 'pf_4_ante',
            name: 'A 4 Ante',
            icon: 'quadFrenchDoor',
            transomOptions: transomOptionsPF4,
            openingTypes: aperturePorta4Ante,
          },
        ],
      },
    ],
  },

  scorrevoli: {
    label: 'Scorrevoli',
    steps: [
      {
        id: 'tipo',
        title: 'TIPO DI SCORREVOLE',
        subtitle: 'Seleziona la configurazione',
        options: [
          {
            id: 'scor_2_ante',
            name: '2 Ante',
            icon: 'slidingDoor',
            subcategoryId: 'scorrevole_2_ante',
            openingTypes: apertureScorrevoli2,
          },
          {
            id: 'scor_3_ante',
            name: '3 Ante',
            icon: 'slidingDoor3',
            subcategoryId: 'scorrevole_3_ante',
            openingTypes: apertureScorrevoli3,
          },
          {
            id: 'scor_4_ante',
            name: '4 Ante',
            icon: 'slidingDoor4',
            subcategoryId: 'scorrevole_4_ante',
            openingTypes: apertureScorrevoli4,
          },
          {
            id: 'scor_minimale',
            name: 'Minimale',
            icon: 'minimalSliding',
            subcategoryId: 'scorrevole_minimale',
            openingTypes: apertureScorrevoli2,
          },
          {
            id: 'scor_traslante',
            name: 'Traslante',
            icon: 'slidingDoor',
            subcategoryId: 'scorrevole_traslante',
            openingTypes: apertureScorrevoli2,
          },
          {
            id: 'scor_angolo',
            name: 'Ad Angolo',
            icon: 'minimalSliding',
            subcategoryId: 'scorrevole_angolo',
          },
        ],
      },
    ],
  },

  // Porte d'ingresso — full multi-step flow
  porte: {
    label: "Porte d'Ingresso",
    // Extra step after the opening: panel type (price add-on in productConfig.doorPanels)
    panelOptions: doorPanels,
    steps: [
      {
        id: 'tipo',
        title: "TIPO DI PORTA D'INGRESSO",
        subtitle: 'Seleziona la configurazione',
        options: [
          {
            id: 'porta_sola',
            name: 'Solo Porta',
            icon: 'entryDoorSingle',
            subcategoryId: 'porta_ingresso_1_anta',
            transomOptions: transomPortaSola,
          },
          {
            id: 'porta_fisso_sx',
            name: 'Porta + Fisso SX',
            icon: 'entryDoorFissoSx',
            subcategoryId: 'porta_ingresso_fisso_sx',
            transomOptions: transomPortaFissoSx,
          },
          {
            id: 'porta_fisso_dx',
            name: 'Porta + Fisso DX',
            icon: 'entryDoorFissoDx',
            subcategoryId: 'porta_ingresso_fisso_dx',
            transomOptions: transomPortaFissoDx,
          },
          {
            id: 'porta_semifisso_sx',
            name: 'Porta + Semifisso SX',
            icon: 'entryDoorSemifissoSx',
            subcategoryId: 'porta_ingresso_semifisso_sx',
            transomOptions: transomPortaSemifissoSx,
          },
          {
            id: 'porta_semifisso_dx',
            name: 'Porta + Semifisso DX',
            icon: 'entryDoorSemifissoDx',
            subcategoryId: 'porta_ingresso_semifisso_dx',
            transomOptions: transomPortaSemifissoDx,
          },
        ],
      },
    ],
  },

  scorrevoli_patio: {
    label: 'Scorri-Ribalta PATIO',
    steps: [
      {
        id: 'tipo',
        title: 'TIPO DI PORTA SCORRI-RIBALTA',
        subtitle: 'Seleziona il numero di ante',
        options: [
          {
            id: 'patio_2_ante',
            name: '2 Ante',
            icon: 'patio2Door',
            subcategoryId: 'patio_2_ante',
            openingTypes: aperturePatio2,
          },
          {
            id: 'patio_3_ante',
            name: '3 Ante',
            icon: 'patio3Door',
            subcategoryId: 'patio_3_ante',
            openingTypes: aperturePatio3,
          },
          {
            id: 'patio_4_ante',
            name: '4 Ante',
            icon: 'patio4Door',
            subcategoryId: 'patio_4_ante',
            openingTypes: aperturePatio4,
          },
        ],
      },
    ],
  },
};

// Which categories use the new multi-step flow
export const multiStepCategories = ['finestre', 'portafinestre', 'scorrevoli', 'scorrevoli_patio', 'porte'];

// Map opening to base opening type for pricing
export function mapOpeningToConfigId(openingId) {
  if (!openingId) return 'battente';
  if (openingId.startsWith('patio_')) return 'scorri_ribalta';
  if (openingId.startsWith('scor_')) return 'scorrevole';
  if (openingId.startsWith('porta_')) return openingId.endsWith('_est') ? 'battente_esterno' : 'battente';
  // Before 'fisso': a fixed sash next to a vasistas is priced as a vasistas window
  if (openingId.includes('vasistas')) return 'vasistas';
  if (openingId.includes('fisso') && !openingId.includes('batt') && !openingId.includes('ar_')) return 'fisso';
  if (openingId.includes('ar_') || openingId.includes('anta_ribalta') || openingId.includes('_ar')) return 'anta_ribalta';
  if (openingId.includes('bilico')) return 'bilico';
  if (openingId.includes('scor')) return 'fisso';
  if (openingId.includes('battente') || openingId.includes('batt')) return 'battente';
  return 'battente';
}
